module.exports = __webpack_public_path__ + "img/vt-switch-sun.5fbe3ec9.svg";